import * as ko from "knockout";
import { BaseService } from "./_common/_baseService";
import { system, LookupStorage } from "portalframework";
import { portalHttpService } from "./_common/httpService";
import * as _ from "lodash";

class PartsService extends BaseService {
  constructor() {
    super("parts");
  }

  getPartsScreenData = async (): Promise<void> => {
    let requiredLookups = ["PART_LINE_CODE"];

    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data = ko.toJSON({ requiredLookups: lookupsToFetch });

    const result = await portalHttpService.post(`${this.baseApiUrl()}/GetPartsScreenData`, data);
    this.setLookupData(lookupsToFetch, result);
  };

  public searchParts = async (
    type: "DEVICE" | "SPAREPART" | "MAINTENANCE_KITS",
    part_id: string,
    model_id: string,
  ): Promise<any[]> => {
    const results: any[] = await portalHttpService.post<any>(
      system.apiURL() + `api/${this.controllerName}/searchParts`,
      ko.toJSON({
        type,
        part_id,
        model_id,
      }),
    );
    results.forEach((p) => {
      p.listDescr = `${p.part_id} - ${p.descr}`;
    });
    return results;
  };

  getPartsForSerialNumber = async (serialNumber: string) => {
    const result = await portalHttpService.get<any[]>(
      `${this.baseApiUrl()}/GetPartsNeedForSerialNumber/${serialNumber}`,
    );
    return result;
  };

  getPartsForRequestId = async (request_id: string) => {
    const result = await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetPartsNeedRequestId/${request_id}`);
    return result;
  };

  protected setLookupData = (lookupsToFetch: string[], results: any) => {
    _.each(lookupsToFetch, (lookupName) => {
      let list = results[lookupName];
      if (list) {
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
  };
}

export const partsService = new PartsService();
